import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { removeCookies, loginPage } from '../../utils';
import { logInOutPushGTM } from '../../googleTagManager';
import './HeaderIcon.scss';

const logout = () => {
  logInOutPushGTM('logout', 'success');
  removeCookies();
  window.location.href = `${window.location.origin}${window.location.pathname}${loginPage}`;
};

const HeaderIcon = ({
  icon = 'arrow',
  backgroundType = 'transparent',
}) => {
  const history = useHistory();
  if (icon === 'logout') {
    return (
      <div className={classnames('logout', backgroundType)} onClick={logout}>
        <FontAwesomeIcon className="logout-icon" icon={faSignOutAlt} />
      </div>
    );
  }
  return (
    <div className={classnames('arrow', backgroundType)} onClick={history.goBack}>
      <FontAwesomeIcon className="arrow-icon" icon={faChevronLeft} />
    </div>
  );
};

HeaderIcon.propTypes = {
  icon: PropTypes.oneOf(['arrow', 'logout']),
  backgroundType: PropTypes.oneOf(['transparent', 'red']),
};

export default HeaderIcon;
